export const TermItemHelper = {
    normalizeData(newData, termItems, useDateIfNoTermSelected = true) {
        if (termItems) {
            // eslint-disable-next-line no-param-reassign
            newData.term_items = termItems.map(item => {
                const dueDate = useDateIfNoTermSelected ? (item.date || null) : null;

                return ({
                    id: item.id || undefined,
                    term_id: item.term_id || null,
                    date: !item.term_id ? dueDate : undefined,
                    description: item.description || null,
                    payment_due: item.payment_due || null,
                });
            });
        }
    },
};
